import { render, staticRenderFns } from "./AssignmentCell.vue?vue&type=template&id=9c6c739a&"
import script from "./AssignmentCell.vue?vue&type=script&lang=js&"
export * from "./AssignmentCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports